import { z } from "zod";

import { x5MachineSchema } from "./x5";

export const x5wPrintServiceMachineSchema = x5MachineSchema.merge(
	z.object({
		iotEdgeDeviceId: z.string(),
		iotHubName: z.string(),
		settings: z.object({
			designId: z.number(),
		}),
	}),
);

export type X5wPrintServiceMachine = z.infer<typeof x5wPrintServiceMachineSchema>;
